import {useCallback} from 'react';

import {GridLayoutItem} from '../../../util/panelbankGrid';

const convertToPixelCoords = ({
  columnWidth,
  gridContainerPadding,
  gridItemMargin,
  gridRowHeight,
  layoutCoords,
}: {
  columnWidth: number;
  gridContainerPadding: number[];
  gridItemMargin: number[];
  gridRowHeight: number;
  layoutCoords: {x: number; y: number};
}) => {
  return {
    x: Math.floor(
      (columnWidth + gridItemMargin[0]) * layoutCoords.x +
        gridContainerPadding[0]
    ),
    y: Math.ceil(
      (gridRowHeight + gridItemMargin[1]) * layoutCoords.y +
        gridContainerPadding[1]
    ),
  };
};

const convertToPixelSize = ({
  columnWidth,
  gridItemMargin,
  gridRowHeight,
  size,
}: {
  columnWidth: number;
  gridItemMargin: number[];
  gridRowHeight: number;
  size: {w: number; h: number};
}) => {
  return {
    w: Math.floor(
      columnWidth * size.w + Math.max(0, size.w - 1) * gridItemMargin[0]
    ),
    h: Math.ceil(
      gridRowHeight * size.h + Math.max(0, size.h - 1) * gridItemMargin[1]
    ),
  };
};

export const useStyleFromGridLayout = ({
  columnWidth,
  gridItemMargin,
  gridRowHeight,
  gridContainerPadding,
}: {
  columnWidth: number;
  gridItemMargin: number[];
  gridRowHeight: number;
  gridContainerPadding: number[];
}) => {
  const getStyleFromLayout = useCallback(
    ({
      layout,
      useTransform,
    }: {
      layout: GridLayoutItem | undefined;
      useTransform: boolean;
    }) => {
      if (layout == null) {
        return {width: 0, height: 0};
      }

      const {x: left, y: top} = convertToPixelCoords({
        layoutCoords: {x: layout.x, y: layout.y},
        columnWidth,
        gridItemMargin,
        gridRowHeight,
        gridContainerPadding,
      });

      const size = convertToPixelSize({
        size: {w: layout.w, h: layout.h},
        columnWidth,
        gridItemMargin,
        gridRowHeight,
      });

      return {
        width: size.w,
        height: size.h,
        ...(useTransform
          ? {
              transform: `translate(${left}px, ${top}px)`,
            }
          : {
              left,
              top,
            }),
      };
    },
    [columnWidth, gridItemMargin, gridRowHeight, gridContainerPadding]
  );

  return getStyleFromLayout;
};
